module.exports = __webpack_public_path__ + "img/cxgys.833f8922.png";